import { CustomError } from 'ts-custom-error';

export class ClientPrefetchError extends CustomError {}
